import { useQuery } from "@tanstack/react-query";

import { getFieldEvaluationMetricCorrections } from "services";

import { GET_FIELD_EVALUATION_METRIC_CORRECTIONS } from "consts";

import { FieldEvaluationMetricCorrectionsResponse } from "models";

export const useGetFieldEvaluationMetricCorrections = ({ fieldIds }: { fieldIds: string[] }) =>
  useQuery<FieldEvaluationMetricCorrectionsResponse>({
    queryKey: [GET_FIELD_EVALUATION_METRIC_CORRECTIONS, fieldIds],
    queryFn: async ({ signal }) => {
      if (fieldIds.length === 0) return {};

      const response = await getFieldEvaluationMetricCorrections({ fieldIds }, signal);
      return response || {};
    },
  });
